<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '新增' : '修改') + '加油费'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      >
      <section slot="order" slot-scope="prop">
        <ChooseOrder
          slot="order"
          :isRadio="true"
          v-model="prop.form.order"
          @change="handleOrderChange"
          :otherSearchData="{orgId}"
        />
      </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import ChooseOrder from 'components/choose/order';
export default {
  components: {
    ChooseOrder,
  },
  props: {
    orgId: {
      type: Number,
    },
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '订单号码',
            value: 'order',
            slot: true,
            default: {},
          },
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
            disabled: true,
          },
          {
            label: '加油升数',
            value: 'oilLitre',
            type: 'input',
            default: '',
            placeholder: '请输入加油升数',
          },
          {
            label: '申请金额',
            value: 'payAmt',
            type: 'input',
            placeholder: '请输入申请金额',
          },
          {
            label: '费用说明',
            value: 'payRemark',
            type: 'input',
            default: '',
            placeholder: '请输入费用说明',
          },
          {
            label: '上传附件',
            value: 'detailPic',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
          },
        ],
        rules: { // 表单验证规则
          order: [ // 订单号码
            { required: true, message: '请选择订单号码', trigger: 'blur' },
          ],
          plateNumber: [ // 车牌号码
            { required: true, message: '请输入车牌号码', trigger: 'blur' },
          ],
          oilLitre: [ // 加油升数
            { required: true, message: '请输入加油升数', trigger: 'blur' },
          ],
          payAmt: [ // 申请金额
            { required: true, message: '请输入申请金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    handleOrderChange (data) {
      this.$refs.customForm.setVal('plateNumber', data.plateNumber); // 车牌号
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        if (item) { // 修改
          this.type = 'edit';
          this.originData = item;
          item.order = {
            orderId: item.orderId,
            plateNumber: item.plateNumber,
          };
          this.$refs.customForm.setVal(item);
        } else { // 新增
          this.type = 'add';
        }
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 订单信息
      form.orderId = String(form.order.orderId);
      delete form.order;
      this.$emit('sub', {
        form,
        originData: this.originData,
      });
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
</style>
